export const DATE_TRIGGER_STEP_COPY = {
  date: {
    stepperLabel: 'Date',
    title: 'Select Date',
    subtitle: 'Choose the date and time for this campaign to start',
    continueLabel: 'Continue to audience →',
  },
  audience: {
    stepperLabel: 'Audience',
    title: 'Select Audience',
    subtitle: 'Choose who this automation sends to',
    listIntro:
      'Sending to a narrower segment — customers who actually want this message — gets higher open rates, fewer spam complaints, and protects your sender reputation over time. Pick "All Users" only when this really is meant for everyone.',
    doneLabel: 'Done',
  },
} as const;

export const DEFAULT_AUDIENCE_LABEL = 'All Users';
/** Shown while segment definitions load and the chosen segment's name isn't known yet. */
export const LOADING_AUDIENCE_LABEL = 'Loading audience...';
export const MISSING_AUDIENCE_LABEL = 'Referenced segment no longer exists — click to reconfigure';

/** Trigger-card clause naming the audience an automation sends to (resolved segment or All Users). */
export const formatSendsToClause = (audienceName: string): string => `Sends to ${audienceName}`;
